<style src="./Burger.scss" lang="scss"></style>

<script>
	import TreeList from '@/components/TreeList/TreeList';

	export default {
		name: 'HpBurger',
		components: {
			'hp-tree-list': TreeList
		},
		data() {
			return {
				hover: false,
				showBurger: false,
				timer: '',
				id: this._uid,
				elements: this.$initialData.burger
			};
		},
		methods: {
			toBurgerOrNotToBurger() {
				this.showBurger = true;
				clearInterval(this.timer);
			},
			checkFocus: function(ev) {
				let checkbox = this.$el.querySelector('input:checked');
				if (checkbox && !this.$el.contains(ev.target)) {
					checkbox.checked = false;
				}
			}
		},
		watch: {
			hover: function(val) {
				if (this.hover) {
					this.timer = setInterval(this.toBurgerOrNotToBurger, 25000);
				} else {
					this.showBurger = false;
					clearInterval(this.timer);
				}
			}
		},
		mounted() {
			this.$nextTick(() => {
				document.addEventListener('click', this.checkFocus);
			});
		}
	};
</script>

<template>
	<div data-component="burger">
		<input type="checkbox" :id="'burger' + id" data-hidden />
		<label :for="'burger' + id" @mouseenter="hover = true" @mouseleave="hover = false" :data-burger="showBurger">
			<span></span>
			<span><div></div></span>
			<span></span>
		</label>
		<div data-layer>
			<label data-grid-end-self="" data-close-button="" :for="'burger' + id"><span></span><span></span></label>
			<header>Alle Inhalte</header>
			<nav>
				<ul>
					<hp-tree-list v-for="(element, index) in elements" :key="index" :element="element"></hp-tree-list>
				</ul>
			</nav>
		</div>
	</div>
</template>
